/* =========================================================
   Comparar perfumes (sections/mt-comparar.liquid)
   - Hasta 4 perfumes, guardados en la dirección (?p=a,b,c): el botón "atrás" deshace el último cambio.
   - Datos: /collections/<col>?view=comparar (templates/collection.comparar.liquid).
   - Similares: lista de los 15 más parecidos (foto, nombre, precio, % y botón), de mayor a menor similitud.
     Similitud de 0 a 1 = familia × 0.30 + notas (Jaccard) × 0.50 + ocasión (Jaccard) × 0.20.
   ========================================================= */
(function () {
  var NIV_ESTELA = ['Suave', 'Moderada', 'Fuerte', 'Enorme'];
  var NIV_DURACION = ['Débil (1–3 h)', 'Moderada (3–6 h)', 'Duradera (7–12 h)', 'Muy duradera (+12 h)'];
  var CONC = { edp: 'Eau de Parfum', edt: 'Eau de Toilette', edc: 'Eau de Cologne', parfum: 'Parfum', elixir: 'Elixir', 'extrait de parfum': 'Extrait de Parfum', cologne: 'Cologne' };
  var MAX_SIMILARES = 15;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function unicos(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }

  /* ---------- Similitud (cada parte de 0 a 1) ---------- */
  var PESO_FAMILIA = 0.30, PESO_NOTAS = 0.50, PESO_OCASION = 0.20;
  // Jaccard: compartidas / total de únicas de ambos
  function jaccard(a, b) {
    a = unicos((a || []).map(norm)); b = unicos((b || []).map(norm));
    if (!a.length && !b.length) return 0;
    var comunes = a.filter(function (x) { return b.indexOf(x) > -1; }).length;
    return comunes / (a.length + b.length - comunes);
  }

  function init(el) {
    if (el.dataset.mtcInit) return; el.dataset.mtcInit = '1';
    var MAX = parseInt(el.dataset.max, 10) || 4;
    var fmt = el.dataset.moneyFormat || '${{amount}}';
    var tabla = el.querySelector('[data-mtc-tabla]');
    var q = el.querySelector('[data-mtc-q]'), res = el.querySelector('[data-mtc-res]'), aviso = el.querySelector('[data-mtc-aviso]');
    var sim = el.querySelector('[data-mtc-sim]'), pista = el.querySelector('[data-mtc-pista]');
    var datos = {}, lista = [];

    function money(c) { return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); }
    function esSet(p) { return /^set\b/i.test(p.t); }
    function familias(p) { return p.fam && p.fam.length ? p.fam : (p.fd ? p.fd.split(/\s+/) : []); }
    // Familia: [principal, subfamilia]. Igual en ambas = 1 · misma principal = 0.5 · distinta = 0
    function simFamilia(a, b) {
      var fa = familias(a).map(norm).filter(Boolean), fb = familias(b).map(norm).filter(Boolean);
      if (!fa.length || !fb.length || fa[0] !== fb[0]) return 0;
      return (fa[1] || '') === (fb[1] || '') ? 1 : 0.5;
    }
    function similitud(a, b) {
      return simFamilia(a, b) * PESO_FAMILIA + jaccard(a.no, b.no) * PESO_NOTAS + jaccard(a.oc, b.oc) * PESO_OCASION;
    }
    function concentracion(p) {
      var m = p.t.match(/\b(extrait de parfum|elixir|parfum|edp|edt|edc|cologne)\b/i);
      if (!m) return '';
      var k = m[1].toLowerCase();
      return k === 'edp' || k === 'edt' || k === 'edc' ? CONC[k] + ' (' + k.toUpperCase() + ')' : CONC[k];
    }
    function tamano(p) { var m = p.t.match(/(\d+(?:[.,]\d+)?)\s*ml/i); return m ? m[1].replace(',', '.') + ' ml' : ''; }

    /* ---------- Dirección (?p=) ---------- */
    function leerUrl() {
      var p = new URLSearchParams(location.search).get('p') || '';
      return unicos(p.split(',').map(function (h) { return h.trim(); })).filter(function (h) { return datos[h]; }).slice(0, MAX);
    }
    function guardar() {
      var u = new URL(location.href);
      u.searchParams.delete('p');
      var resto = u.searchParams.toString();
      var qs = (lista.length ? 'p=' + lista.map(encodeURIComponent).join(',') : '') + (resto ? (lista.length ? '&' : '') + resto : '');
      history.pushState({ mtc: lista.slice() }, '', u.pathname + (qs ? '?' + qs : ''));
    }
    window.addEventListener('popstate', function () { lista = leerUrl(); pintar(); });

    function agregar(h) {
      if (lista.indexOf(h) > -1) return;
      if (lista.length >= MAX) { mostrarAviso(el.dataset.txtLleno); return; }
      lista.push(h); guardar(); pintar();
    }
    function quitar(h) { lista = lista.filter(function (x) { return x !== h; }); guardar(); pintar(); }
    function mostrarAviso(t) { aviso.textContent = t; aviso.hidden = false; clearTimeout(aviso.mtT); aviso.mtT = setTimeout(function () { aviso.hidden = true; }, 3500); }

    // En celular el botón dice solo la primera palabra ("Agregar")
    function etiquetaCarrito() {
      var t = el.dataset.txtAgregar || '', i = t.indexOf(' ');
      return i < 0 ? esc(t) : esc(t.slice(0, i)) + '<span class="mtc-resto">' + esc(t.slice(i)) + '</span>';
    }

    /* ---------- Tabla ---------- */
    function barra(valor, niveles) {
      var i = niveles.indexOf(valor);
      if (i < 0) return '<span class="mtc-nd">—</span>';
      var s = '<span class="mtc-barra" aria-label="' + esc(valor) + '">';
      for (var k = 0; k < niveles.length; k++) s += '<i' + (k <= i ? ' class="on"' : '') + '></i>';
      return s + '</span><span class="mtc-barra__txt">' + esc(valor) + '</span>';
    }
    function chips(arr, comunes) {
      if (!arr || !arr.length) return '<span class="mtc-nd">—</span>';
      return '<span class="mtc-chips">' + arr.map(function (x) { return '<span class="mtc-chip' + (comunes && comunes.indexOf(x) > -1 ? ' is-comun' : '') + '">' + esc(x) + '</span>'; }).join('') + '</span>';
    }

    function pintar() {
      var ps = lista.map(function (h) { return datos[h]; });
      var hueco = ps.length < MAX;
      var n = ps.length + (hueco ? 1 : 0);
      el.style.setProperty('--mtc-n', n);
      el.classList.toggle('mtc--vacia', !ps.length);

      // notas que se repiten entre los perfumes elegidos
      var cuenta = {}, comunes = [];
      ps.forEach(function (p) { unicos(p.no).forEach(function (x) { cuenta[x] = (cuenta[x] || 0) + 1; }); });
      Object.keys(cuenta).forEach(function (k) { if (cuenta[k] > 1) comunes.push(k); });

      var filas = [
        { et: 'Estela', val: function (p) { return p.es || ''; }, html: function (p) { return barra(p.es, NIV_ESTELA); } },
        { et: 'Duración', val: function (p) { return p.du || ''; }, html: function (p) { return barra(p.du, NIV_DURACION); } },
        { et: 'Familia olfativa', val: function (p) { return familias(p).join(' '); }, html: function (p) { var f = p.fam && p.fam.length ? p.fam.join(' · ') : p.fd; return f ? '<span class="mtc-txt">' + esc(f) + '</span>' : '<span class="mtc-nd">—</span>'; } },
        { et: 'Ocasión', val: function (p) { return (p.oc || []).slice().sort().join(','); }, html: function (p) { return chips(p.oc); } },
        { et: 'Notas', val: function (p) { return (p.no || []).slice().sort().join(','); }, html: function (p) { return chips(p.no, comunes); } },
        { et: 'Tamaño', val: tamano, html: function (p) { var t = tamano(p); return t ? '<span class="mtc-txt">' + esc(t) + '</span>' : '<span class="mtc-nd">—</span>'; } },
        { et: 'Concentración', val: concentracion, html: function (p) { var c = concentracion(p); return c ? '<span class="mtc-txt">' + esc(c) + '</span>' : '<span class="mtc-nd">—</span>'; } },
        { et: 'Precio', val: function (p) { return String(p.p); }, html: function (p) { return '<span class="mtc-precio">' + money(p.p) + (p.c > p.p ? ' <s>' + money(p.c) + '</s>' : '') + '</span>'; } }
      ];

      var vacia = hueco ? '<div class="mtc-celda mtc-celda--hueco"></div>' : '';
      var cab = '<div class="mtc-fila mtc-fila--cab"><div class="mtc-et"></div>' + ps.map(function (p) {
        return '<div class="mtc-celda mtc-prod">' +
          '<button type="button" class="mtc-quitar" data-mtc-quitar="' + esc(p.h) + '" aria-label="Quitar ' + esc(p.t) + '">×</button>' +
          '<a href="' + esc(p.u) + '" class="mtc-prod__link">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '<span class="mtc-prod__sinfoto"></span>') +
          '<span class="mtc-prod__nombre">' + esc(p.t) + '</span></a></div>';
      }).join('') + (hueco ? '<div class="mtc-celda mtc-mas"><button type="button" class="mtc-mas__btn" data-mtc-mas><span>+</span>Agregar perfume</button></div>' : '') + '</div>';

      var cuerpo = filas.map(function (f) {
        var vals = ps.map(f.val), distinta = ps.length > 1 && unicos(vals).length > 1;
        return '<div class="mtc-fila' + (distinta ? ' is-dif' : '') + '"><div class="mtc-et">' + esc(f.et) + '</div>' +
          ps.map(function (p) { return '<div class="mtc-celda">' + f.html(p) + '</div>'; }).join('') + vacia + '</div>';
      }).join('') +
        '<div class="mtc-fila mtc-fila--btn"><div class="mtc-et"></div>' + ps.map(function (p) {
          return '<div class="mtc-celda">' + (p.a && p.v
            ? '<button type="button" class="mt-btn mtc-carrito" data-mtc-carrito="' + p.v + '"><span>' + etiquetaCarrito() + '</span></button>'
            : '<button type="button" class="mt-btn mtc-carrito" disabled><span>' + esc(el.dataset.txtAgotado) + '</span></button>') + '</div>';
        }).join('') + vacia + '</div>';

      if (!ps.length) {
        tabla.innerHTML = '<div class="mtc-vacio"><p>Busca un perfume arriba para empezar a comparar.</p></div>';
      } else {
        tabla.innerHTML = '<div class="mtc-cab" data-mtc-cab>' + cab + '</div><div class="mtc-cuerpo" data-mtc-cuerpo>' + cuerpo + '</div>';
        sincronizar();
      }
      q.disabled = false;
      pintarSimilares();
    }

    // En celular la cabecera y el cuerpo se deslizan juntos
    function sincronizar() {
      var a = tabla.querySelector('[data-mtc-cab]'), b = tabla.querySelector('[data-mtc-cuerpo]');
      if (!a || !b) return;
      var bloqueo = false;
      function copiar(de, a2) { return function () { if (bloqueo) return; bloqueo = true; a2.scrollLeft = de.scrollLeft; requestAnimationFrame(function () { bloqueo = false; }); }; }
      a.addEventListener('scroll', copiar(a, b), { passive: true });
      b.addEventListener('scroll', copiar(b, a), { passive: true });
    }

    tabla.addEventListener('click', function (e) {
      var x = e.target.closest('[data-mtc-quitar]'); if (x) { quitar(x.dataset.mtcQuitar); return; }
      if (e.target.closest('[data-mtc-mas]')) { q.focus(); q.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      var c = e.target.closest('[data-mtc-carrito]'); if (c) alCarrito(c);
    });

    /* ---------- Agregar al carrito (abre el carrito lateral) ---------- */
    function alCarrito(btn) {
      var id = parseInt(btn.dataset.mtcCarrito, 10);
      btn.disabled = true; btn.classList.add('is-cargando');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (r) {
        if (r.status) { mostrarAviso(r.description || r.message || 'No se pudo agregar.'); return; }
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.renderContents === 'function' && r.sections) { cd.classList.remove('is-empty'); cd.renderContents({ sections: r.sections, id: id }); }
        else location.href = '/cart';
      }).catch(function () { location.href = '/cart'; })
        .finally(function () { btn.disabled = false; btn.classList.remove('is-cargando'); });
    }

    /* ---------- Buscador ---------- */
    var activo = -1, encontrados = [];
    function buscar() {
      var t = norm(q.value).trim();
      if (!t) { res.hidden = true; res.innerHTML = ''; return; }
      var pal = t.split(/\s+/);
      encontrados = Object.keys(datos).map(function (h) { return datos[h]; }).filter(function (p) {
        if (esSet(p) || lista.indexOf(p.h) > -1) return false;
        var nt = norm(p.t);
        return pal.every(function (w) { return nt.indexOf(w) > -1; });
      }).sort(function (a, b) { return (b.a - a.a) || a.t.localeCompare(b.t); }).slice(0, 8);
      activo = -1;
      res.innerHTML = encontrados.length ? encontrados.map(function (p, i) {
        return '<li><button type="button" class="mtc-res__item" data-i="' + i + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '<span class="mtc-res__sinfoto"></span>') +
          '<span class="mtc-res__nombre">' + esc(p.t) + '</span><span class="mtc-res__precio">' + money(p.p) + '</span></button></li>';
      }).join('') : '<li class="mtc-res__nada">No encontramos ese perfume.</li>';
      res.hidden = false;
    }
    function elegir(i) { var p = encontrados[i]; if (!p) return; q.value = ''; res.hidden = true; agregar(p.h); }
    var tq;
    q.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(buscar, 120); });
    q.addEventListener('focus', function () { if (q.value) buscar(); });
    q.addEventListener('keydown', function (e) {
      var items = res.querySelectorAll('.mtc-res__item');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!items.length) return;
        activo = (activo + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (b, i) { b.classList.toggle('is-activo', i === activo); });
      } else if (e.key === 'Enter') { e.preventDefault(); elegir(activo < 0 ? 0 : activo); }
      else if (e.key === 'Escape') { res.hidden = true; }
    });
    res.addEventListener('click', function (e) { var b = e.target.closest('.mtc-res__item'); if (b) elegir(parseInt(b.dataset.i, 10)); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.mtc-buscar')) res.hidden = true; });

    /* ---------- Similares: lista de los 15 más parecidos ---------- */
    function pintarSimilares() {
      var ps = lista.map(function (h) { return datos[h]; });
      if (!ps.length) { sim.hidden = true; return; }
      // Con varios perfumes elegidos se usa el promedio de la similitud con cada uno
      var puntos = Object.keys(datos).map(function (h) { return datos[h]; }).filter(function (c) {
        return c.a && !esSet(c) && lista.indexOf(c.h) < 0;
      }).map(function (c) {
        var s = 0;
        ps.forEach(function (p) { s += similitud(p, c); });
        return { p: c, s: s / ps.length };
      }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s; }).slice(0, MAX_SIMILARES);
      if (!puntos.length) { sim.hidden = true; return; }
      var lleno = lista.length >= MAX;
      pista.innerHTML = puntos.map(function (x) {
        var p = x.p;
        return '<div class="mtc-sim__fila">' +
          '<a class="mtc-sim__foto" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="mtc-sim__info" href="' + esc(p.u) + '"><span class="mtc-sim__nombre">' + esc(p.t) + '</span>' +
          '<span class="mtc-sim__precio">' + money(p.p) + (p.c > p.p ? ' <s>' + money(p.c) + '</s>' : '') + '</span></a>' +
          '<span class="mtc-sim__pct" title="Similitud">' + Math.round(x.s * 100) + '%</span>' +
          '<button type="button" class="mtc-sim__btn" data-mtc-sumar="' + esc(p.h) + '"' + (lleno ? ' disabled title="' + esc(el.dataset.txtLleno) + '"' : '') + '>' + esc(el.dataset.txtComparar) + '</button></div>';
      }).join('');
      sim.hidden = false;
    }
    pista.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mtc-sumar]'); if (!b) return;
      agregar(b.dataset.mtcSumar);
      el.querySelector('.mtc-buscar').scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    /* ---------- Carga del índice ---------- */
    q.disabled = true;
    var base = '/collections/' + el.dataset.col + '?view=comparar';
    fetch(base).then(function (r) { return r.json(); }).then(function (j) {
      var paginas = [Promise.resolve(j)];
      for (var i = 2; i <= (j.paginas || 1); i++) paginas.push(fetch(base + '&page=' + i).then(function (r) { return r.json(); }));
      return Promise.all(paginas);
    }).then(function (todas) {
      todas.forEach(function (j) { (j.items || []).forEach(function (p) { p.no = p.no || []; p.oc = p.oc || []; datos[p.h] = p; }); });
      lista = leerUrl();
      history.replaceState({ mtc: lista.slice() }, '', location.href);
      pintar();
    }).catch(function () {
      tabla.innerHTML = '<div class="mtc-vacio"><p>No pudimos cargar los perfumes. Recarga la página.</p></div>';
    });
  }

  function arrancar() { document.querySelectorAll('[data-mtc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
